import { computed } from 'vue'

export function useNavItems() {
  const user = window.gon?.user || {}

  const navItems = computed(() => {
    if (!user.id) {
      return [
        { title: 'Стартовая страница', link: '/' }
      ]
    }

    const items = [
      { title: 'Абитуриент', link: '/abiturient' },
    ]

    if (user.is_secretary) {
      items.push({ title: 'Сотрудник ПК', link: '/secretary' })
    }

    if (user.is_admin) {
      items.push({
        title: 'Управление',
        link: '/admin',
        children: [
          { title: 'Контакты', link: '/admin/contacts' },
          { title: 'Sidekiq', link: '/sidekiq' }
        ],
      })
    }

    return items
  })

  return { navItems }
}
